/** @file Checkbox with a visible label: the native input keeps keyboard and screen-reader behaviour. */
import './tokens.css';
import './Checkbox.css';
import { joinClass } from './logic/joinClass';

/** Props of Checkbox. */
export interface CheckboxProps {
  checked: boolean;
  /** Already-translated label (or an API field name), shown after the box. */
  label: string;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

/** Controlled checkbox; `onChange` fires with the new state. */
export function Checkbox({ checked, label, onChange, disabled = false }: CheckboxProps) {
  return (
    <label className={joinClass('p2-checkbox', disabled && 'p2-checkbox-disabled')}>
      <input type="checkbox" checked={checked} disabled={disabled} onChange={(e) => { onChange(e.currentTarget.checked); }} />
      <span className="p2-checkbox-label">{label}</span>
    </label>
  );
}
